/*
 * cart-tee-zoom.js
 * --------------------------------------------------------------------------
 * Click-to-enlarge for the teeinblue customization image in the cart
 * (cart page + cart drawer). A magnifier badge (CSS) signals it's tappable;
 * clicking opens a full-screen lightbox with the full-resolution design.
 *
 * The cart re-renders its contents on every update (cart.js / cart-drawer.js),
 * so we bind via EVENT DELEGATION on document — no per-item listeners to lose.
 * The lightbox node is built once and reused.
 * --------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var THUMB_SEL = '.tee-cart-thumbnail';
  var overlay = null;
  var overlayImg = null;
  var lastFocus = null;

  function build() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'tee-cart-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="tee-cart-lightbox__close" aria-label="Sluiten">' +
        '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
          '<line x1="2" y1="2" x2="16" y2="16"/><line x1="16" y1="2" x2="2" y2="16"/>' +
        '</svg>' +
      '</button>' +
      '<img class="tee-cart-lightbox__img" alt="">';
    document.body.appendChild(overlay);
    overlayImg = overlay.querySelector('.tee-cart-lightbox__img');

    // Click the backdrop (anything that isn't the image) closes it.
    overlay.addEventListener('click', function (e) {
      if (e.target !== overlayImg) close();
    });

    return overlay;
  }

  function open(src, alt) {
    if (!src) return;
    build();
    overlayImg.src = src;
    overlayImg.alt = alt || '';
    lastFocus = document.activeElement;
    // Force a reflow so the opening transition runs from the hidden state.
    overlay.offsetHeight; // eslint-disable-line no-unused-expressions
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var closeBtn = overlay.querySelector('.tee-cart-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest ? e.target.closest(THUMB_SEL) : null;
    if (!thumb) return;
    var img = thumb.querySelector('img[data-tee-image]');
    if (!img) return;
    e.preventDefault();
    open(img.dataset.teeSrc || img.src, img.alt);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) close();
  });
})();
